import React from 'react';
import { ReactComponent as UserIcon } from '../../assets/svg/icons/user.svg';

const SocialProof = ({ social_proof, social_proof_data, uniName } = props) => {
    return social_proof && social_proof_data >= 200 ? (
        <div className="social-proof-container">{prepareSocialProofText(social_proof_data, uniName)}</div>
    ) : null;
};

const prepareSocialProofText = (sotialProofData, uniName) => {
    if (sotialProofData < 500) {
        return <p>Join hundreds who have gained first hand insights into life at {uniName}</p>;
    }
    return (
        <p>
            Join{' '}
            <span className="social-proof-amount">
                <UserIcon /> {sotialProofData} people
            </span>{' '}
            who have gained first hand insights into life at {uniName}
        </p>
    );
};

export default SocialProof;
